
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("6pT9Z", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "getMeatballMenuItems", () => $3b5025dd08fdb010$export$f1bcb9d7a06e7ed3);
$parcel$export(module.exports, "MeatballMenu", () => $3b5025dd08fdb010$export$ef4a0fdddd7eccb7);
$parcel$export(module.exports, "default", () => $3b5025dd08fdb010$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $bFzGY = parcelRequire("bFzGY");

var $7u4fN = parcelRequire("7u4fN");

var $6OfWd = parcelRequire("6OfWd");
var $hD6GJ = parcelRequire("hD6GJ");
var $fEubG = parcelRequire("fEubG");

var $jG1wZ = parcelRequire("jG1wZ");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $gUUjF = parcelRequire("gUUjF");

var $guiFP = parcelRequire("guiFP");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $1c02D = parcelRequire("1c02D");
var $irg9D = parcelRequire("irg9D");

var $5JgJ2 = parcelRequire("5JgJ2");

var $cBaEp = parcelRequire("cBaEp");

var $cHJdq = parcelRequire("cHJdq");

var $eMdFV = parcelRequire("eMdFV");

var $9Anw5 = parcelRequire("9Anw5");

var $jMP2a = parcelRequire("jMP2a");

var $6yplV = parcelRequire("6yplV");

var $kXgPy = parcelRequire("kXgPy");


var $iLbHw = parcelRequire("iLbHw");

var $69AFd = parcelRequire("69AFd");
const $3b5025dd08fdb010$var$FeedbackTitleDetails = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $3b5025dd08fdb010$var$feedbackTitleDetailsContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage((0, $69AFd.default).feedbackTitleDetails)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage((0, $69AFd.default).feedbackTitleDetailsContactSupport)));
};
const $3b5025dd08fdb010$export$f1bcb9d7a06e7ed3 = (data)=>data && data.flatMap((group)=>group.items.filter((item)=>item.id !== (0, $59bd40111a092cf7$export$df7b2838a6fc207e) && item.id !== (0, $59bd40111a092cf7$export$efad93080758a558)));
const $3b5025dd08fdb010$export$ef4a0fdddd7eccb7 = ({ jql: jql, filterId: filterId = '', searchResultPageData: searchResultPageData, additionalMenuItems: additionalMenuItems })=>{
    const { data: data, loading: loading, error: error, fetch: fetch, requestPayload: requestPayload } = (0, $kXgPy.useMeatballMenuItems)(searchResultPageData);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const isNinChangeboardingEnabled = (0, $eUqFw.useContext)((0, $cHJdq.NinChangeboardingContext));
    const isAnonymous = (0, $6yplV.useIsAnonymous)();
    const shouldShowOptOut = isNinChangeboardingEnabled && !isAnonymous;
    const { openFeedbackCollector: openFeedbackCollector } = (0, $irg9D.useFeedbackCollectorActions)();
    const meatballMenuItems = $3b5025dd08fdb010$export$f1bcb9d7a06e7ed3(data) || [];
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const lastUsedRequestPayload = (0, $eUqFw.useRef)();
    const hasPreviousError = (0, $eUqFw.useRef)(false);
    const fireMenuItemAnalytic = (0, $eUqFw.useCallback)((menuItemId)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked'
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'dropdownItem clicked', 'meatballMenu', {
            dropdownItem: menuItemId
        });
    }, [
        createAnalyticsEvent
    ]);
    const fireBulkEditFormAnalytic = (0, $eUqFw.useCallback)((menuItemId)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'submitted'
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'bulkEditForm submitted', 'meatballMenu', {
            dropdownItem: menuItemId
        });
    }, [
        createAnalyticsEvent
    ]);
    const fireErrorAnalyticWhenFormIsNotInitialised = (0, $eUqFw.useCallback)((menuItemId)=>{
        const err = new Error(`Bulk edit form with id ${menuItemId} is not set`);
        (0, $guiFP.default)({
            meta: {
                id: 'submitBulkEditForm',
                packageName: 'jiraIssueNavigatorActionMeatballMenu',
                teamName: 'empanada'
            },
            sendToPrivacyUnsafeSplunk: true,
            error: err
        });
    }, []);
    const submitBulkEditForm = (0, $eUqFw.useCallback)((item)=>{
        const form = document.getElementById(`export-bulk-items-form-${item.id}`);
        if (!(form instanceof HTMLFormElement)) {
            fireErrorAnalyticWhenFormIsNotInitialised(item.id);
            return;
        }
        fireBulkEditFormAnalytic(item.id);
        form.submit();
    }, [
        fireErrorAnalyticWhenFormIsNotInitialised,
        fireBulkEditFormAnalytic
    ]);
    const isBulkEdit = (item)=>item.id === (0, $59bd40111a092cf7$export$66cb530046350ea5) || item.id === (0, $59bd40111a092cf7$export$efad93080758a558);
    const onClickDropdownItem = (0, $eUqFw.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (item)=>(event)=>{
            // Disable browser link behaviour
            event.preventDefault();
            if (isBulkEdit(item)) submitBulkEditForm(item);
            else if (typeof item.link === 'string' && item.link.length > 0) // We need to use Javascript to open this in a new tab/window so that we can use Javascript to close it later
            window.open(item.link);
            fireMenuItemAnalytic(item.id);
        }, [
        fireMenuItemAnalytic,
        submitBulkEditForm
    ]);
    let OptOutFragment = null;
    const getBulkEditFormFragment = (item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3b5025dd08fdb010$var$BulkEditForm, {
            "data-testid": "issue-navigator-action-meatball-menu.ui.export-bulk-items-form",
            id: `export-bulk-items-form-${item.id}`,
            method: "post",
            target: "_blank",
            action: item.link
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("input", {
            "data-testid": "issue-navigator-action-meatball-menu.ui.export-bulk-items-jql",
            type: "hidden",
            name: "jql",
            value: jql
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("input", {
            "data-testid": "issue-navigator-action-meatball-menu.ui.export-bulk-items-filter-id",
            type: "hidden",
            name: "filterId",
            value: filterId
        })); /**
                    * In most cases, clicking the bulk edit option will be handled by submitBulkEditForm which will serialise the JQL
                    * as part of the form payload, thus avoiding any server restrictions on URI length. However, we still need to
                    * specify the JQL parameter in the anchor tag href so the correct issues are shown when right-clicking + opening in
                    * new tab. That means it's still possible to encounter a 414 error for long JQL queries via the right-click menu,
                    * but it's more important that we show users the correct issue results in this instance.
                    */ 
    const getItemLink = (0, $eUqFw.useCallback)((item)=>{
        if (isBulkEdit(item) && jql && (0, $eI5EY.fg)('empanada_bulk_edit_url_for_right_click')) try {
            const bulkEditUrl = new URL(item.link, window.location.origin);
            const issueSearchParams = {
                jql: jql
            };
            const newParams = new URLSearchParams([
                ...Array.from(bulkEditUrl.searchParams.entries()),
                ...Object.entries(issueSearchParams)
            ]).toString();
            return `${bulkEditUrl.pathname}?${newParams}`;
        } catch (err) {
            // TODO Remove temporary logging after rollout of empanada_bulk_edit_url_for_right_click
            (0, $gUUjF.default).unsafeErrorWithCustomerData('jiraIssueNavigatorActionMeatballMenu.getItemLink', `Encountered an error parsing bulk edit item URL: ${item.link}`, err instanceof Error ? err : undefined);
        }
        return item.link ?? '#';
    }, [
        jql
    ]);
    if ((0, $1ybV0.ff)('nin.global-scope_aqec8')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const globalScopeOptOut = (0, $eMdFV.useGlobalScopeOptOutFlow)(); // eslint-disable-next-line react-hooks/rules-of-hooks
        const onOptOut = (0, $eUqFw.useCallback)(async ()=>{
            fireMenuItemAnalytic((0, $59bd40111a092cf7$export$e389676e8d50a810));
            globalScopeOptOut();
        }, [
            fireMenuItemAnalytic,
            globalScopeOptOut
        ]);
        OptOutFragment = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3b5025dd08fdb010$var$FooterDivider, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fEubG.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
            key: (0, $59bd40111a092cf7$export$e389676e8d50a810),
            onClick: onOptOut
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
            "data-testid": "issue-navigator-action-meatball-menu.ui.opt-out-feedback"
        }, formatMessage((0, $69AFd.default).actionsOptOutDisplayText)))));
    }
    (0, $eUqFw.useEffect)(()=>{
        const isMeatballMenuOpenedWithNewPayload = isOpen && JSON.stringify(requestPayload) !== JSON.stringify(lastUsedRequestPayload.current);
        if (!loading && !hasPreviousError.current && isMeatballMenuOpenedWithNewPayload) {
            // @ts-expect-error - TS2345 - Argument of type 'RequestPayload | undefined' is not assignable to parameter of type 'RequestPayload'.
            fetch(requestPayload); // should not be potentially undefined after isM71ColumnConfigEnabled cleanup
            lastUsedRequestPayload.current = requestPayload;
        } // If there was a fetch error, we clear the lastUsedRequestPayload
        if (error) {
            hasPreviousError.current = true;
            lastUsedRequestPayload.current = undefined;
        }
    }, [
        fetch,
        isOpen,
        loading,
        requestPayload,
        error
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6OfWd.default), {
        isLoading: loading && JSON.stringify(requestPayload) === JSON.stringify(lastUsedRequestPayload.current),
        onOpenChange: (nextState)=>{
            if (nextState.isOpen) hasPreviousError.current = false;
            setIsOpen(nextState.isOpen);
        },
        isOpen: isOpen,
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                ...props,
                testId: "issue-navigator-action-meatball-menu.ui.menu-trigger",
                spacing: "default",
                isSelected: isOpen,
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jG1wZ))), {
                    label: !(0, $1ybV0.ff)('nin.global-scope_aqec8') || !shouldShowOptOut ? formatMessage((0, $69AFd.default).actionsButtonLabel) : formatMessage((0, $69AFd.default).actionsButtonWithOptOutLabel),
                    size: "medium"
                }),
                ref: triggerRef
            }),
        shouldFlip: true,
        placement: "bottom-end",
        spacing: "compact",
        testId: "issue-navigator-action-meatball-menu.ui.dropdown-menu"
    }, !error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fEubG.default), null, additionalMenuItems, meatballMenuItems && meatballMenuItems.map((option)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iLbHw.DropdownItemLink), {
            key: option.id,
            menuItemId: option.id,
            onClick: onClickDropdownItem(option),
            href: getItemLink(option),
            target: "_blank",
            styleClass: option.styleClass
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
            "data-testid": "issue-navigator-action-meatball-menu.ui.menu-item"
        }, option.label), isBulkEdit(option) && getBulkEditFormFragment(option))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
        key: (0, $59bd40111a092cf7$export$3c1bb52064935485),
        onClick: ()=>openFeedbackCollector({
                entrypointId: (0, $1c02D.ENTRYPOINT_ID_JIRA_PLATFORM),
                feedbackGroupId: 'issue-navigator',
                feedbackTitle: formatMessage((0, $69AFd.default).feedbackTitle),
                feedbackTitleDetails: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3b5025dd08fdb010$var$FeedbackTitleDetails, null),
                feedbackContext: [
                    {
                        id: (0, $1c02D.EntryKeys).LOCATION,
                        value: (0, $9Anw5.default)(window?.location?.href ?? '')
                    },
                    {
                        id: (0, $1c02D.EntryKeys).SCREEN_RESOLUTION,
                        value: `${window?.screen?.width ?? 'unknown'} x ${window?.screen?.height ?? 'unknown'}`
                    },
                    {
                        id: (0, $1c02D.EntryKeys).USER_AGENT,
                        value: window?.navigator?.userAgent ?? 'unknown'
                    },
                    {
                        id: 'spreadsheet-redesign',
                        value: (0, $1ybV0.ff)('jsv-one-issue-table-spreadsheet-ui_ygrnf').toString()
                    }
                ],
                feedbackGroupLabels: {
                    // Custom dropdown placeholder
                    empty: {
                        selectOptionLabel: formatMessage((0, $69AFd.default).feedbackTypePlaceholder)
                    },
                    // Use default labels for other options
                    bug: {},
                    comment: {},
                    suggestion: {},
                    question: {}
                }
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        "data-testid": "issue-navigator-action-meatball-menu.ui.give-feedback"
    }, formatMessage((0, $69AFd.default).actionsGiveFeedbackDisplayText)))), (0, $1ybV0.ff)('nin.global-scope_aqec8') && shouldShowOptOut && OptOutFragment) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cBaEp.ErrorState), {
        onRetry: ()=>{
            // @ts-expect-error - TS2345 - Argument of type 'RequestPayload | undefined' is not assignable to parameter of type 'RequestPayload'.
            fetch(requestPayload); // should not be potentially undefined after isM71ColumnConfigEnabled cleanup
            lastUsedRequestPayload.current = requestPayload;
        },
        pageAction: "meatballMenu"
    }));
};
var $3b5025dd08fdb010$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $3b5025dd08fdb010$export$ef4a0fdddd7eccb7;
const $3b5025dd08fdb010$var$BulkEditForm = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "form", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0cglyw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3b5025dd08fdb010$var$FooterDivider = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq _x3doqpbm _otyr1b66 _19pk1b66",
            __cmplp.className
        ])
    });
});
const $3b5025dd08fdb010$var$feedbackTitleDetailsContainerStyles = (0, $1ZAYh.xcss)({
    marginBottom: 'space.300'
});

});
parcelRegister("kXgPy", function(module, exports) {

$parcel$export(module.exports, "useMeatballMenuItems", () => $d1ecc7b15b2eb40f$export$dcc369963df3381d);

var $eUqFw = parcelRequire("eUqFw");

var $53ciZ = parcelRequire("53ciZ");

var $eEzyV = parcelRequire("eEzyV");

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");
const $d1ecc7b15b2eb40f$export$162e19c052deab0b = '/rest/issueNav/1/issueNav/operations/tools';
const $d1ecc7b15b2eb40f$export$34482912a4c2747c = (options)=>(0, $lRmyA.performPostRequest)($d1ecc7b15b2eb40f$export$162e19c052deab0b, {
        credentials: 'same-origin',
        body: (0, $53ciZ.stringify)(options),
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            'X-Atlassian-Token': 'no-check',
            __amdModuleName: 'jira/issue/utils/xsrf-token-header'
        }
    });
const $d1ecc7b15b2eb40f$export$dcc369963df3381d = (searchResultPageData)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { loading: loading, error: error, data: data, fetch: fetch } = (0, $eEzyV.useService)($d1ecc7b15b2eb40f$export$34482912a4c2747c);
    const { offset: offset, pages: pages, total: total } = searchResultPageData;
    const requestPayload = {
        offset: offset,
        searchResultsTotal: total,
        searchResultsPages: pages,
        // useColumns and skipColumns aren't used in the endpoint but is required for the constructor
        useColumns: false,
        skipColumns: false,
        new: true
    };
    (0, $eUqFw.useEffect)(()=>{
        if (loading) return;
        if (error) (0, $guiFP.default)({
            error: error,
            event: createAnalyticsEvent({}),
            meta: {
                id: 'useMeatballMenuItems'
            }
        });
        else if (data) (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'useMeatballMenuItems succeeded', 'meatballMenu');
    }, [
        createAnalyticsEvent,
        data,
        error,
        loading
    ]);
    return {
        loading: loading,
        error: error,
        data: data,
        fetch: fetch,
        requestPayload: requestPayload
    };
};

});

const $59bd40111a092cf7$export$8a0f2e68464a820f = 'bulk_create_dd_link';
const $59bd40111a092cf7$export$efad93080758a558 = 'bulkedit_curr_pg';
const $59bd40111a092cf7$export$66cb530046350ea5 = 'bulkedit_all';
const $59bd40111a092cf7$export$df7b2838a6fc207e = 'gin-meatball-menu-clear-sorts';
const $59bd40111a092cf7$export$e389676e8d50a810 = 'opt-out-feedback';
const $59bd40111a092cf7$export$c1dcd93cb65a1cc5 = 'connect-app';
const $59bd40111a092cf7$export$3c1bb52064935485 = 'give-feedback';
const $59bd40111a092cf7$export$a7a312131aa962e0 = 'go-to-all-issues';

parcelRegister("iLbHw", function(module, exports) {

$parcel$export(module.exports, "DropdownItemLink", () => $f12181be934473ee$export$4b2b604fbc992db7);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $bFzGY = parcelRequire("bFzGY");

var $hD6GJ = parcelRequire("hD6GJ");

var $jMP2a = parcelRequire("jMP2a");
const $f12181be934473ee$export$4b2b604fbc992db7 = ({ styleClass: styleClass, onClick: onClick, name: name, children: children, href: href, menuItemId: menuItemId })=>{
    const webItemLinkRef = (0, $eUqFw.useRef)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const analyticsEvent = createAnalyticsEvent({
        action: 'clicked'
    });
    const onClickWebItem = (e)=>{
        if (webItemLinkRef.current?.classList.contains('ap-dialog')) {
            e.preventDefault();
            webItemLinkRef.current?.click();
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'dropdownItem clicked', 'meatballMenu', {
                dropdownItem: menuItemId
            });
            return;
        }
        onClick(e);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
        onClick: onClickWebItem,
        href: href,
        target: "_blank"
    }, children), styleClass && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f12181be934473ee$var$HiddenLink, {
        ref: webItemLinkRef,
        href: href,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: styleClass
    }, name));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f12181be934473ee$var$HiddenLink = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0cglyw",
            __cmplp.className
        ])
    });
});

});

parcelRegister("69AFd", function(module, exports) {

$parcel$export(module.exports, "default", () => $caf19e4dcff20231$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $caf19e4dcff20231$var$messages = (0, $90IgZ.defineMessages)({
    actionsButtonLabel: {
        "id": "issue-navigator-action-meatball-menu.actions-button-label",
        "defaultMessage": "Import and bulk change issues"
    },
    actionsButtonWithOptOutLabel: {
        "id": "issue-navigator-action-meatball-menu.actions-button-with-opt-out-label",
        "defaultMessage": "Import and bulk change issues; Go back to the old issue search"
    },
    actionsOptOutDisplayText: {
        "id": "issue-navigator-action-meatball-menu.actions-opt-out-display-text",
        "defaultMessage": "Go back to the old issue search"
    },
    actionsGiveFeedbackDisplayText: {
        "id": "issue-navigator-action-meatball-menu.actions-give-feedback-display-text",
        "defaultMessage": "Give feedback"
    },
    feedbackTitle: {
        "id": "issue-navigator-action-meatball-menu.feedback-title",
        "defaultMessage": "Give feedback for issue search"
    },
    feedbackTitleDetails: {
        "id": "issue-navigator-action-meatball-menu.feedback-title-details",
        "defaultMessage": "Let us know how we can improve this experience."
    },
    feedbackTitleDetailsContactSupport: {
        "id": "issue-navigator-action-meatball-menu.feedback-title-details-contact-support",
        "defaultMessage": "If you\u2019re having technical issues, contact our support team."
    },
    feedbackTypePlaceholder: {
        "id": "issue-navigator-action-meatball-menu.feedback-type-placeholder",
        "defaultMessage": "Select an option"
    }
});
var $caf19e4dcff20231$export$2e2bcd8739ae039 = $caf19e4dcff20231$var$messages;

});



//# sourceMappingURL=async-issue-navigator-actions-meatball-menu.6bb8e3a5.js.map
